import React from 'react';

interface IntegrationCardProps {
  logo?: string;
  name: string;
  category: string;
  description: string;
  isSyncing: boolean;
  onClick: () => void;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  logo,
  name,
  category,
  description,
  isSyncing,
  onClick,
}) => {
  const handleClick = () => {
    if (!isSyncing) {
      onClick();
    }
  };

  return (
    <div
      className={`p-2 w-60 card border border-gray-200 rounded-lg shadow-md 
                transition-all duration-100 relative
                ${isSyncing
          ? 'cursor-wait pointer-events-none'
          : 'hover:shadow-lg hover:-translate-y-0.2 active:shadow-sm active:translate-y-0 cursor-pointer'
        }`}
      onClick={handleClick}
    >
      {isSyncing && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-lg z-10">
          <div className="flex items-center gap-2">
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-15 font-bold text-white">Syncing...</span>
          </div>
        </div>
      )}
      <div className="flex items-center gap-2">
        <img src={logo} alt="" className="border border-gray-200 rounded-full h-9" />
        <div>
          <span className="font-bold">{name}</span>
          <p>{category}</p>
        </div>
      </div>
      <div className="mt-2">{description}</div>
    </div>
  );
};

export default IntegrationCard;